import { ErrorView } from "./ErrorView";

interface VideoProps {
    src: string;
    type?: string;
}

export const Video = ({src, type = "video/mp4"}: VideoProps) => 
    <video autoPlay loop controls>
        <source src={src} type={type} />
        <ErrorView error={Error('Your browser does not support the video tag ;(')} />
    </video>
